module.exports = __webpack_public_path__ + "static/media/hero_bg.f3b54c22.jpg";